
import Vue from "vue";
import { mapState } from "vuex";
import { IRootState } from "@/store/types";
import { AUTH } from "@/store/auth";

import { routes, ROUTE_NAMES } from "@/routes";

export default Vue.extend({
  props: {
    submenu: String
  },
  methods: {
    isActive(item: any) {
      const currentRoute = this.$route;
      return (
        currentRoute.path === item.path ||
        currentRoute.name === item.name ||
        // matches "child" routes
        currentRoute.path.includes(item.path)
      );
    }
  },
  computed: {
    items(): any[] {
      const roles = (this as any).roles;
      return routes
        .filter(route => route.meta && route.meta.submenu === this.submenu && route.meta.label)
        .sort((a: any, b: any) => a.meta.sortOrder - b.meta.sortOrder)
        .map(route => ({
          label: route.meta && route.meta.label,
          name: route.name,
          path: route.path,
          roles: route.meta && route.meta.requireRole
        }))
        // filter out routes base on the users role
        .filter(
          route => !route.roles ||
            (roles && route.roles.some((role: string) => roles.indexOf(role) >= 0))
        );
    },
    routes: () => ROUTE_NAMES,
    ...mapState({
      roles: (state: IRootState) => state.auth.roles
    })
  }
});
